var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash"},[_c('div',{staticClass:"md-layout login"},[_c('div',{staticClass:"md-layout-item"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.svg")}})])])])
}]

export { render, staticRenderFns }